// Turn Haxe get_/set_ accessor methods into real JS properties on every exposed nape class.
function napeDefineProps(root){
  function fix(target, names){
    names.forEach(function(name){
      var m = /^get_(\w+)$/.exec(name);
      if (!m) return;
      var prop = m[1];
      if (Object.prototype.hasOwnProperty.call(target, prop)) return;
      var getter = target[name], setter = target['set_'+prop];
      Object.defineProperty(target, prop, {
        get: getter,
        set: setter || function(){ throw new Error('nape: property '+prop+' is read-only'); },
        configurable: true
      });
    });
  }
  function walk(ns){
    for (var k in ns){
      var v = ns[k];
      if (typeof v === 'function' && v.prototype){
        fix(v.prototype, Object.getOwnPropertyNames(v.prototype));
        fix(v, Object.getOwnPropertyNames(v));
      } else if (v && typeof v === 'object') walk(v);
    }
  }
  walk(root);
  return root;
}
if (typeof module !== 'undefined') module.exports = napeDefineProps;
